module.exports = __webpack_public_path__ + "img/logo.652ac767.svg";